import styled from '@emotion/styled'
import { Text } from 'components/Typography'

export const SSelectCountryPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`

export const SOptionsList = styled.div`
  display: flex;
  flex-direction: column;
`

export const SSearchInput = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  border-bottom: 1px solid var(--c-gray30);
  outline: none;
  font-size: 1rem;
  background: white;
  position: sticky;
  top: 0;
  z-index: 1;
`

export const SOption = styled.div<{ highlighted?: boolean }>`
  display: flex;
  text-align: left;
  align-items: center;
  width: 100%;
  padding: 1rem;
  cursor: pointer;
  background-color: ${({ highlighted }) => (highlighted ? 'var(--c-blue100)' : 'white')};
  transition: background-color 0.2s;
  font: inherit;

  :hover,
  :focus {
    background-color: var(--c-blue100);
  }
`

export const SSelectCountryPicker = styled.button`
  display: flex;
  z-index: 1;
  cursor: pointer !important;
  height: 100%;
  width: 5rem !important;
  padding: 0.3rem 0.5rem !important;
  margin: 0;
  outline: none;
  background-color: transparent;
  justify-content: space-evenly;
  align-items: center;

  &[data-open='true'] > svg:last-child {
    transform: rotate(180deg);
  }
`

export const SIconWrapper = styled.div`
  width: 2rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  & > * {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
  }
`

export const SFlagImg = styled.img`
  width: 2rem;
  object-fit: contain;
  margin-right: 1rem;
`

export const SLabel = styled(Text)`
  flex: 1;
  margin-right: 0.5rem;
  color: var(--c-gray100);
`

export const SEmptyState = styled(Text)`
  padding: 1rem;
  color: var(--c-gray500);
`
